import { getSortedFormFields } from '@utils/forms';
import { helpWithOptionsConsolidated } from './GreenLakeCentralSupportFormOptions';

export const getGreenLakeCentralSupportFormData = (target, helpWith, helpWithSecondary) => {
  let namespace: string;
  let subject: string;
  let category: string;

  switch (helpWith) {
    case helpWithOptionsConsolidated.hpeGreenLakeML:
      namespace = 'hpe_flex_mlops';
      subject = 'Flex MLOps';
      category = 'HPE GreenLake for ML Ops';
      break;
    case helpWithOptionsConsolidated.hpeGreenLakeSAP:
      namespace = 'hpe_flex_s4hana';
      subject = 'Flex S4Hana';
      category = 'HPE GreenLake for SAP S/4HANA pe cdc';
      break;
    case helpWithOptionsConsolidated.hpeGreenLakeHPC:
      namespace = 'hpe_flex_hpc';
      subject = 'Flex HPC';
      category = 'HPE Greenlake for HPC';
      break;
    case helpWithOptionsConsolidated.hpeGreenLakeMS:
      namespace = 'hpe_flex_gms';
      subject = 'Flex MS';
      category = 'HPE GreenLake Management Services';
      break;
    case helpWithOptionsConsolidated.hpeGreenLakeAzure:
      namespace = 'hpe_flex_azurehci';
      subject = 'Flex Azure HCI';
      category = 'HPE GreenLake for Azure Stak HCI';
      break;
    case helpWithOptionsConsolidated.hpeGreenLakeOpenShift:
      namespace = 'hpe_flex_openshift';
      subject = 'Flex Openshift';
      category = 'HPE GreenLake for RedHat OpenShift Container Platform';
      break;
    case helpWithOptionsConsolidated.hpeGreenLakeVCF:
      namespace = 'hpe_flex_vcf';
      subject = 'Flex VCF';
      category = 'HPE GreenLake for Vmware Cloud Foundation (VCF)';
      break;
    default:
      namespace = 'hpe_greenlake_central';
      subject = 'Flex Solutions';
      category = '';
      break;
  }

  subject += ` : ${helpWith} - ${helpWithSecondary ? helpWithSecondary + ', ' : ''}{formId}`

  return getSortedFormFields(target, namespace, subject, category);
};
